import Link from "next/link";
import { ReactNode } from "react";

interface Props {
  prefix?: ReactNode;
  postfix?: ReactNode;
  color?: string;
  className?: string;
}

export const PrivacyPolicy = ({ prefix, postfix, color, className }: Props) => {
  return (
    <div
      tw="font-base text-[8px] font-normal leading-[17px] tracking-[1px] text-center"
      className={className}
    >
      {prefix}
      <Link href="/terms" passHref>
        <a tw="text-theme" css={{ color }}>
          利用規約
        </a>
      </Link>
      と
      <Link href="/privacy_policy" passHref>
        <a tw="text-theme" css={{ color }}>
          プライバシーポリシー
        </a>
      </Link>
      {postfix}
    </div>
  );
};
